import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'react-bootstrap';
import { ReactComponent as ArrowLeft } from 'assets/images/icons/ArrowLeft.svg';

const BackButton = ({ className, variant = 'link', href = '' }) => {
    const { t, i18n } = useTranslation();

    const homepageToken = 'homepage_url';
    const hasHomepageToken = i18n.exists(homepageToken) && t(homepageToken).trim() !== '';
    const url = hasHomepageToken ? t(homepageToken) : href;

    return !url ? null : (
        <Button
            className={className}
            variant={variant}
            href={url}
        >
            <ArrowLeft className="btn-ico btn-ico-left" />
            {t('header_back_homepage')}
        </Button>
    );
};

export default BackButton;
